const AvatarIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
            <path d="M6.34128 0C8.44283 0 10.146 1.56714 10.146 3.5C10.146 5.43286 8.44283 7 6.34128 7C4.23973 7 2.53651 5.43286 2.53651 3.5C2.53651 1.56714 4.23973 0 6.34128 0ZM6.34128 0C8.44283 0 10.146 1.56714 10.146 3.5C10.146 5.43286 8.44283 7 6.34128 7C4.23973 7 2.53651 5.43286 2.53651 3.5C2.53651 1.56714 4.23973 0 6.34128 0ZM4.9143 8.16714H8.0857C10.7992 8.16714 13 10.1914 13 12.6871V12.9786C13 13.9629 10.7992 14 8.0857 14H4.9143C2.20075 14 0 13.9986 0 12.9786V12.6871C0 10.19 2.20075 8.16714 4.9143 8.16714Z" fill="#CA9D2A"/>
        </svg>
    );
};

export default AvatarIcon;